export const filterDataForOrderOfListView = (items, setListData, setTotalItems) => {
  const { results: data = [], count = 0 } = items;
  setListData(data);
  setTotalItems(count);
};

export const useAllocationData = (allocation, selectedView, baseData, filteredData) => {
  if (selectedView.is_view_rule_exists) {
    if (allocation === "transfer") return filteredData.transfer;
    if (allocation === "purchase") return filteredData.purchase;
  }
  if (allocation === "transfer") return baseData.transfer;
  if (allocation === "purchase") return baseData.purchase;
  if (allocation === "salesOrder") return baseData.salesOrder;
  if (allocation === "manufacturingOrder") return baseData.manufacturingOrder;
  return baseData.purchase;
};

export const closeCreateView = setIsOpenCreateView => {
  setIsOpenCreateView({ isOpen: false, isEditMode: false });
};

export const listRowIdentity = item => item?.list_row_key || item?.id;

export const handleCheckedOrder = (e, listData, setSelectedOrder, selectedOrder) => {
  if (e.target.tagName === "td" || !(e.target.tagName === "INPUT")) return;

  if (e.target.value === "all") {
    const orders = e.target.checked ? listData : [];
    setSelectedOrder(orders);
    return;
  }

  if (e.target.tagName === "INPUT") {
    try {
      const val = JSON.parse(e.target.value);
      const rowKey = listRowIdentity(val);
      if (e.target.checked) {
        setSelectedOrder([...selectedOrder, val]);
      } else {
        setSelectedOrder(
          selectedOrder.filter(order => listRowIdentity(order) !== rowKey),
        );
      }
    } catch (error) {}
  }
};
